import React, { useCallback } from 'react';
import { array, bool, func, shape, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import BinaryTargetTypeSelect from './BinaryTargetTypeSelect';

import {
    isTargetSelected,
    optionsTransform,
    targetChangeHandler,
    RULE_TARGET_TO_TYPE
} from './targetMappings';
import { fetchSystemTypes } from '../../../actions/systemTypeActions';
import { fetchSystemTypesLookup } from '../../../actions/lookupActions';

const SystemsTargetSelect = ({
    disabled,
    errors,
    fetchSystemTypes,
    fetchSystemTypesLookup,
    onPatch,
    onChange,
    touched,
    values,
    ...props
}) => {
    const dispatch = useDispatch();
    const systemTypes = useSelector(
        ({ systemTypes }) => systemTypes
    );

    const handleChange = useCallback(
        targetChangeHandler(onPatch, {
            targetSystemTypes: []
        })
    );

    function handleRenderable() {
        dispatch(fetchSystemTypesLookup());
    }

    const options = [
        {
            error:     systemTypes.error,
            isLoading: systemTypes.loading,
            items:     optionsTransform(systemTypes.data),
            name:      'Systems',
            itemProps: {
                type: RULE_TARGET_TO_TYPE.targetSystemTypes
            }
        }
    ];

    return (
        <BinaryTargetTypeSelect
            controlValue="System"
            disabled={disabled}
            errors={errors}
            grouped
            isItemSelected={isTargetSelected}
            kickerText="Add any System Types that this Rule will be applied to"
            label="Systems"
            onRenderable={handleRenderable}
            onTargetChange={onChange}
            onTargetTypeChange={handleChange}
            options={options}
            placeholder="Add Systems"
            ruleId={values.id}
            ruleTemplateId={values.ruleTemplateId}
            target={values.target}
            targetType={systemTypes}
            touched={touched}
            value={values.targetSystemTypes}
            {...props}
        />
    );
};

SystemsTargetSelect.defaultProps = {
    disabled: false,
    errors:   {},
    fetchSystemTypes,
    fetchSystemTypesLookup,
    onChange: () => {},
    onPatch:  () => {},
    touched:  {},
    values:   {
        targetSystemTypes: []
    }
};

SystemsTargetSelect.propTypes = {
    disabled: bool,
    errors:   shape({
        target: string
    }),
    fetchSystemTypes:       func,
    fetchSystemTypesLookup: func,
    onChange:               func,
    onPatch:                func,
    touched:                shape({
        target: bool
    }),
    values: shape({
        id:                string,
        target:            string,
        targetSystemTypes: array.isRequired
    })
};

export default SystemsTargetSelect;
